if (!customElements.get('ewa-product-card')) {
  class EwaProductCard extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      this._media = this.querySelector('[data-ewa-media]');
      this._hit = this.querySelector('[data-ewa-media-hit]');
      if (!this._media || !this._hit) return;

      this._active = 0;
      this._swipeHandled = false;
      this._abort = new AbortController();
      const { signal } = this._abort;

      this._slides = [];
      this._segments = [];
      if (this._media.classList.contains('ewa-card__media--gallery')) {
        this._slides = Array.from(this._media.querySelectorAll('[data-ewa-slide]'));
        this._segments = Array.from(this._media.querySelectorAll('[data-ewa-segment]'));
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const touchGallery = this._slides.length > 1 && !reducedMotion;

      if (touchGallery) {
        this._preloadImages();

        if (finePointer) {
          this._onMove = (event) => this._setActive(this._indexFromClientX(event.clientX));
          this._onLeave = () => this._setActive(0);
          this._hit.addEventListener('mousemove', this._onMove, { signal });
          this._hit.addEventListener('mouseleave', this._onLeave, { signal });
        }

        if (!finePointer) {
          this._initTouchGallery(signal);
        }
      }

      this._hit.addEventListener(
        'click',
        (event) => {
          if (!this._swipeHandled) return;
          event.preventDefault();
          this._swipeHandled = false;
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this._abort?.abort();
    }

    _indexFromClientX(clientX) {
      const rect = this._media.getBoundingClientRect();
      const ratio = (clientX - rect.left) / rect.width;
      const clamped = Math.min(0.999, Math.max(0, ratio));
      return Math.floor(clamped * this._slides.length);
    }

    _setActive(index) {
      if (!this._slides.length || index === this._active) return;
      this._active = index;
      this._slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this._segments.forEach((segment, i) => segment.classList.toggle('is-active', i === index));
    }

    _preloadImages() {
      this._slides.forEach((slide, index) => {
        if (index === 0) return;
        const img = slide.querySelector('img');
        if (!img || img.complete) return;
        const preload = new Image();
        preload.src = img.currentSrc || img.src;
      });
    }

    _initTouchGallery(signal) {
      const SWIPE_THRESHOLD = 36;
      let startX = 0;
      let startY = 0;
      let tracking = false;

      this._hit.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          this._swipeHandled = false;
        },
        { passive: true, signal }
      );

      this._hit.addEventListener(
        'touchmove',
        (event) => {
          if (!tracking || event.touches.length !== 1) return;
          const dx = event.touches[0].clientX - startX;
          const dy = event.touches[0].clientY - startY;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 12) {
            this._swipeHandled = true;
          }
        },
        { passive: true, signal }
      );

      this._hit.addEventListener(
        'touchend',
        (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < SWIPE_THRESHOLD) return;
          if (dx < 0) {
            this._setActive(Math.min(this._active + 1, this._slides.length - 1));
          } else {
            this._setActive(Math.max(this._active - 1, 0));
          }
          this._swipeHandled = true;
        },
        { passive: true, signal }
      );
    }
  }

  customElements.define('ewa-product-card', EwaProductCard);
}

document.addEventListener('click', (event) => {
  const atc = event.target.closest('[data-ewa-atc]');
  if (atc) {
    event.preventDefault();
    event.stopPropagation();

    const variantId = atc.getAttribute('data-ewa-atc');
    if (!variantId || atc.classList.contains('is-loading')) return;

    atc.classList.add('is-loading');

    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: variantId, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        atc.classList.remove('is-loading');
        atc.classList.add('is-added');
        setTimeout(() => atc.classList.remove('is-added'), 1600);
        if (drawer && data.sections) {
          drawer.renderContents(data);
          if (drawer.open) drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(() => {
        atc.classList.remove('is-loading');
        window.location.href = `${window.Shopify.routes.root}cart`;
      });
    return;
  }
});
